import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react'

import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';

import { useUser } from '../../Context';

export const LoginModal = ({
  isOpen,
  onClose,
  initialState = 'signIn',
}) => {

  const { setUser } = useUser();

  // Function to get full user info including groups
  const refreshUserWithGroups = async () => {
    try {
      const currentUser = await getCurrentUser();
      if (currentUser) {
        const session = await fetchAuthSession();
        const groups = session.tokens?.accessToken?.payload?.['cognito:groups'] || [];
        
        const userWithGroups = {
          ...currentUser,
          signInUserSession: {
            accessToken: {
              payload: {
                'cognito:groups': groups
              }
            }
          }
        };
        
        setUser(userWithGroups);
      }
    } catch (error) {
      console.error('Error refreshing user info:', error);
    }
  };

  return (
    <Modal size="xl" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Login</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Authenticator 
            initialState={initialState}
            signUpAttributes={['email']}
            components={{
              SignUp: {
                Header() {
                  return (
                    <Text fontSize="lg" fontWeight="bold" mb={2}>
                      Create Account
                    </Text>
                  );
                },
                Footer() {
                  return (
                    <Text fontSize="sm" color="gray.600" mt={2} textAlign="center">
                      Password must be at least 8 characters with uppercase, lowercase, and numbers.
                      <br />
                      Only registered members can create accounts.
                    </Text>
                  );
                }
              }
            }}
          >
            {({ signOut, user }) => {
              // Trigger full user refresh after login
              refreshUserWithGroups();
              return (
                <>
                  <Text mb={6} >Logged in as <strong>{user.username}</strong></Text>
                  <Button onClick={signOut}>Logout</Button>
                </>
              )
            }
            }
          </Authenticator>
        </ModalBody>
        <ModalFooter>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}